import React, { useState, useRef, useEffect } from 'react'
import Blocks from './_Blocks'
import Headline from '../atoms/Headline'
import SbEditable from 'storyblok-react'

const AccordionBlock = ({ block }) => {
  const [activeAccordionState, setActiveAccordionState] = useState(null)
  const refContainers = useRef([])

  const refContainersCollection = (el) => {
    if (el && !refContainers.current.includes(el)) {
      refContainers.current.push(el)
    }
  }

  // Workaround: Verhindert falsche Start-Höhe des Contents, weil Bild zu lange zum Laden braucht. => Refactoring
  useEffect(() => {
    setTimeout(() => {
      setActiveAccordionState(0)
    }, 1000)
  }, [])

  const toggleAccordion = (index) => {
    const newActiveAccordionState =
      activeAccordionState !== index ? index : null
    setActiveAccordionState(newActiveAccordionState)
  }

  return (
    <SbEditable content={block}>
      <section className="accordion-block">
        <div className="accordion-block-wrapper">
          <div className="accordion-block-container">
            <Headline
              kicker={block.kicker}
              headline={block.headline}
              subheadline={block.subheadline}
              headline_level={block.headline_level}
            />

            <div className="accordion accordion-block-accordion">
              {block.accordion_card?.length > 0 &&
                block.accordion_card.map((item, index) => (
                  <div className="card accordion-block-card" key={index}>
                    <div className="card-header accordion-block-card-header">
                      <h3 className="mb-0">
                        <button
                          className={`btn btn-accordion ${
                            activeAccordionState === index ? '' : 'collapsed'
                          }`}
                          onClick={() => toggleAccordion(index)}
                        >
                          {item.title}
                        </button>
                      </h3>
                    </div>

                    <div
                      className={`collapse collapsing show`}
                      ref={refContainersCollection}
                      style={{
                        height: `${
                          activeAccordionState === index
                            ? `${refContainers?.current[index]?.scrollHeight}px`
                            : '0px'
                        }`,
                      }}
                    >
                      <div className="card-body accordion-block-card-body">
                        {item.content?.length > 0 &&
                          item.content.map((content) =>
                            React.createElement(Blocks(content.component), {
                              key: content._uid,
                              block: content,
                              type: content.component,
                            })
                          )}
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </section>
    </SbEditable>
  )
}

export default AccordionBlock
